const GROUP_LABELS = {
  pitcher: "Starting Pitcher",
  offense: "Team Statistics",
  lineup: "Lineup",
  bullpen: "Bullpen",
  rest: "Rest",
  park: "Park",
  weather: "Weather",
  league_context: "League Context",
};

const GROUPED_KEYS = new Set(["pitcher", "offense", "lineup", "bullpen", "rest", "recent_form"]);

// The server-side audit collapses "insufficient_data" into "unavailable" for the pass/fail
// coverage count (unchanged, not touched here) -- this reads the raw per-block payload only to
// pick a more honest chip LABEL, never to change availability/available_count math.
const displayStatus = (key, payload, isAvailable) => {
  if (isAvailable) return "available";
  const block = payload?.[key];
  if (!block) return "unavailable";
  const statuses = GROUPED_KEYS.has(key) ? [block.home?.status, block.away?.status] : [block.status];
  return statuses.includes("insufficient_data") ? "insufficient_data" : "unavailable";
};

const STATUS_LABEL = { available: "Available", insufficient_data: "Insufficient Data", unavailable: "Unavailable" };
const STATUS_STYLE = {
  available: "border-emerald-500/40 bg-emerald-500/10 text-emerald-400",
  insufficient_data: "border-amber-500/40 bg-amber-500/10 text-amber-400",
  unavailable: "border-zinc-700 bg-zinc-800/50 text-zinc-500",
};
const STATUS_DOT = { available: "bg-emerald-400", insufficient_data: "bg-amber-400", unavailable: "bg-zinc-600" };

export const FeatureCoverageBar = ({ coverage, availability, payload }) => {
  if (!coverage) return null;
  return (
    <div data-testid="feature-coverage-bar" className="flex flex-col gap-3">
      <div className="flex flex-wrap gap-2">
        {coverage.groups.map((key) => {
          const isAvailable = availability?.[key] === "available";
          const status = displayStatus(key, payload, isAvailable);
          return (
            <span
              key={key}
              data-testid={`feature-coverage-item-${key}`}
              className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-mono text-[10px] uppercase tracking-wide ${STATUS_STYLE[status]}`}
            >
              <span className={`h-1.5 w-1.5 rounded-full ${STATUS_DOT[status]}`} />
              {GROUP_LABELS[key] || key} {STATUS_LABEL[status]}
            </span>
          );
        })}
      </div>
      <p data-testid="feature-coverage-summary" className="font-mono text-xs text-zinc-500">
        {coverage.available_count} / {coverage.total_count} major feature groups available &mdash; a data-quality
        indicator only, not a betting confidence score.
      </p>
    </div>
  );
};
